namespace Matrix.Exceptions {
    export class ExceptionInboxColumns {
        static columnsKey = 'Matrix.Exceptions.Columns.ExceptionInboxColumns';
    }
}
